import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useForm, Controller } from 'react-hook-form';
import { ModalHeader } from 'shared/ModalHeader';

const RenameColumnDialog = ({ visible, onHide, onSubmit, currentName }) => {
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
  } = useForm({
    defaultValues: {
      stageName: currentName || '',
    },
    mode: 'onChange',
  });

  const stageName = watch('stageName');

  React.useEffect(() => {
    if (visible && currentName) {
      reset({ stageName: currentName });
    }
  }, [visible, currentName, reset]);

  const onSubmitForm = async (data) => {
    await onSubmit(data.stageName);
    onHide();
  };

  const handleCancel = () => {
    reset({ stageName: currentName });
    onHide();
  };

  return (
    <Dialog className="new-task-popup" visible={visible} style={{ width: '450px' }} onHide={handleCancel} footer={<></>} closable={false}>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <div className="modal-heading F-size16 text-bold mb-3">Rename Stage</div>

        <div className="p-field">
          <label htmlFor="stageName" className="font-weight-bold">
            Stage Name <span className="text-danger">*</span>
          </label>
          <Controller
            name="stageName"
            control={control}
            rules={{
              required: 'Stage name is required',
              minLength: {
                value: 3,
                message: 'Stage name must be at least 3 characters',
              },
              maxLength: {
                value: 50,
                message: 'Stage name must not exceed 50 characters',
              },
              validate: (value) => {
                const trimmed = value.trim();
                if (trimmed.length < 3) {
                  return 'Stage name must be at least 3 characters (excluding spaces)';
                }
                return true;
              },
            }}
            render={({ field }) => (
              <InputText
                {...field}
                id="stageName"
                className={`w-100 mt-2 ${errors.stageName ? 'p-invalid' : ''}`}
                autoFocus
                placeholder="Enter stage name"
                disabled={isSubmitting}
              />
            )}
          />
          {errors.stageName && <small className="p-error d-block mt-1">{errors.stageName.message}</small>}
          <small className="d-block mt-2 text-muted">{stageName?.length || 0}/50 characters</small>
        </div>
        <div className="footer-btn">
          <div className="col-12 d-flex justify-content-end">
            <Button label="Cancel" className="p-button-secondary outline" disabled={isSubmitting} onClick={handleCancel} />
            <Button
              label="Rename"
              className="p-button-secondary ms-2"
              onClick={handleSubmit(onSubmitForm)}
              loading={isSubmitting}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </form>
    </Dialog>
  );
};

export default RenameColumnDialog;
